import { Injectable, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GlobalsService } from "./globals.service";
import { Feature, FeatureSet } from "./feature.model";
import { ConfigService } from "./config.service";

@Injectable({ providedIn: "root" })
export class AppService {
  public features: Feature[] = [];

  public constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private globalsService: GlobalsService,
  ) {
    const config = this.configService.readConfig();
    this.globalsService.setAppCongig(config);
  }

  public getSectionFeatures(section: string): Feature[] {
    const featureSet: FeatureSet = this.globalsService.getFeatureSet();
    if (featureSet?.features?.length > 0) {
      const sectionFeatures: Feature[] = featureSet?.features.filter(
        (m) => m.section.name === section,
      );
      return sectionFeatures;
    }

    return [];
  }
}
